import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电视剧", to: "/category/电视剧" },
  { label: "电影", to: "/category/电影" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const submitSearch = (event: FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/search?q=${encodeURIComponent(value)}`);
    setMenuOpen(false);
    setSearchOpen(false);
  };

  const isActive = (to: string) => {
    const path = decodeURIComponent(location.pathname);
    if (to === "/") return path === "/";
    return path.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex shrink-0 items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-heart-3-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 whitespace-nowrap">
              恋爱的味道
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  isActive(item.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <form onSubmit={submitSearch} className="hidden md:block">
            <div className="flex h-10 w-56 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 lg:w-72">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                placeholder="搜索爱情影视作品…"
                className="h-full w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
            </div>
          </form>

          <div className="flex items-center gap-1 md:hidden">
            <button
              type="button"
              aria-label="搜索"
              onClick={() => setSearchOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700"
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <form onSubmit={submitSearch} className="pb-3 md:hidden">
            <div className="flex h-10 w-full items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                placeholder="搜索爱情影视作品…"
                className="h-full w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
              <button type="submit" className="text-sm font-medium text-primary-600 whitespace-nowrap">
                搜索
              </button>
            </div>
          </form>
        )}
      </div>

      {menuOpen && (
        <nav className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setMenuOpen(false)}
              className={`block rounded-md px-4 py-3 text-sm font-medium ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}